import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import shoots from "../data/shootData";
import "./ViewStoryDetails.css";

const ViewStoryDetails = () => {

     useEffect(() => {
        AOS.init({
          duration: 1000, // animation duration
          once: true,     // animate only once
          disable: 'mobile' // disable on mobile devices
        });
      }, []);

  // console.log(shoots);

  const { id } = useParams();
  const navigate = useNavigate();
  const shoot = shoots.find((s) => s.id === parseInt(id));

  if (!shoot) {
    return (
      <div className="text-center text-light py-5">
        <h2>Story Not Found 😔</h2>
        <button className="btn btn-danger mt-3" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="story-view bg-black text-light" data-aos="zoom-out">
      {/* ===== Hero Banner ===== */}
      <div
        className="story-hero position-relative"
        style={{
          backgroundImage: `url(${shoot.cover})`,
        }}
      >
        <div className="overlay"></div>
        <div className="hero-content text-center position-absolute top-50 start-50 translate-middle">
          <h1 className="fw-bold display-4 glowing-text">{shoot.title}</h1>
          <p className="lead text-white-50">{shoot.description}</p>
        </div>
      </div>

      {/* ===== Photo Gallery ===== */}
      <div className="container py-5">
        <h2 className="text-center text-danger fw-bold mb-5">
          Capturing Eternal Moments 💫
        </h2>
        <div className="gallery-grid">
          {shoot.photos.map((photo, index) => (
            <div key={index} className="gallery-item">
              <img src={photo} alt={`Wedding ${index + 1}`} className="gallery-img" />
            </div>
          ))}
        </div>

        {/* ===== Video Section ===== */}
        {shoot.id !== 2 && shoot.id !== 3 && (
          <>
            <h2 className="text-center text-danger fw-bold mt-5 mb-4">
              Relive the Moments 🎥
            </h2>
            <div className="video-grid">
              {shoot.videos.map((video, index) => (
                <video
                  key={index}
                  src={video}
                  controls
                  className="video-frame"
                />
              ))}
            </div>
          </>
        )}

        <div className="text-center mt-5">
          <button className="btn btn-outline-danger px-4" onClick={() => navigate(-1)}>
            ← Back to Stories
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewStoryDetails;
